import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import API from "../../../services/interceptor";
import ClientDetailsForm from "./ClientDetailsForm";

const ClientProfile = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { loginUser } = useContext(AuthContext);
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Use the current user's ID if no ID is provided in params
  const userId = id || loginUser?.id;

  useEffect(() => {
    if (userId) {
      fetchClientData();
    } else {
      setError("No user ID provided");
      setLoading(false);
    }
  }, [userId]);

  const fetchClientData = async () => {
    try {
      setLoading(true);
      const response = await API.get(`/api/user/${userId}`);

      if (response.data) {
        setClient(response.data);
      } else {
        setError("Client not found");
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setError("Client not found");
      } else {
        setError(error.message || "Failed to fetch client data");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSuccess = () => {
    // Refresh client data after successful update
    fetchClientData();
    // You can also show a success message or redirect
  };

  const handleCancel = () => {
    // Navigate back or close modal
    navigate("/dashboard");
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading client profile...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="text-red-500 text-6xl mb-4">❌</div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Error</h2>
          <p className="text-gray-600 mb-6">{error}</p>
          <button
            onClick={() => navigate("/dashboard")}
            className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors"
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <ClientDetailsForm
        userId={client._id}
        onSuccess={handleSuccess}
        onCancel={handleCancel}
      />
    </div>
  );
};

export default ClientProfile;
